module.exports = __webpack_public_path__ + "static/media/app-icon-nh.530161cf.svg";